export default __webpack_public_path__ + "static/media/meryl.47581d95.png";